import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";
import { cn } from "@/lib/utils";
export const WordPressIcon = t0 => {
  const $ = _c(10);
  let className;
  let svg;
  if ($[0] !== t0) {
    ({
      className,
      ...svg
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = svg;
  } else {
    className = $[1];
    svg = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("size-12", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g clipPath="url(#clip0_2932_1811)"><path d="M1.70508 11.9982C1.70508 16.073 4.07315 19.5945 7.50704 21.2632L2.59636 7.80859C2.02516 9.08891 1.70508 10.5058 1.70508 11.9982Z" fill="#ffffff" /><path d="M18.9495 11.4818C18.9495 10.2095 18.4925 9.32838 18.1005 8.64258C17.5787 7.79459 17.0895 7.07647 17.0895 6.22848C17.0895 5.28215 17.8073 4.40125 18.8182 4.40125C18.8639 4.40125 18.9072 4.40693 18.9516 4.40948C17.1201 2.73152 14.6799 1.70703 11.9998 1.70703C8.40334 1.70703 5.23918 3.55228 3.39844 6.34719C3.63997 6.35444 3.86759 6.35953 4.06093 6.35953C5.13771 6.35953 6.80451 6.22887 6.80451 6.22887C7.35946 6.19616 7.42488 7.01124 6.87052 7.07686C6.87052 7.07686 6.31284 7.14249 5.69227 7.175L9.44114 18.3258L11.694 11.5691L10.0901 7.17461C9.53575 7.14209 9.01058 7.07647 9.01058 7.07647C8.45583 7.04396 8.52087 6.19577 9.07562 6.22848C9.07562 6.22848 10.7757 6.35914 11.7873 6.35914C12.8639 6.35914 14.5309 6.22848 14.5309 6.22848C15.0862 6.19577 15.1514 7.01085 14.5969 7.07647C14.5969 7.07647 14.038 7.14209 13.4186 7.17461L17.1389 18.241L18.1657 14.8097C18.6108 13.3858 18.9495 12.3631 18.9495 11.4818Z" fill="#ffffff" /><path d="M12.1805 12.8984L9.0918 21.8738C10.014 22.1449 10.9893 22.2931 11.9999 22.2931C13.1988 22.2931 14.3484 22.0859 15.4185 21.7096C15.3909 21.6655 15.3658 21.6187 15.3453 21.5678L12.1805 12.8984Z" fill="#ffffff" /><path d="M21.0338 7.0625C21.078 7.39041 21.1031 7.74242 21.1031 8.12107C21.1031 9.16573 20.908 10.3401 20.3203 11.8084L17.1758 20.9001C20.2363 19.1154 22.2949 15.7996 22.2949 12.0018C22.2951 10.212 21.8379 8.52891 21.0338 7.0625Z" fill="#ffffff" /><path d="M12.0004 0C5.38355 0 0 5.38315 0 12C0 18.6176 5.38355 24.0006 12.0004 24.0006C18.617 24.0006 24.0014 18.6176 24.0014 12C24.0012 5.38315 18.617 0 12.0004 0ZM12.0004 23.4505C5.68697 23.4505 0.550245 18.3138 0.550245 12C0.550245 5.68658 5.68678 0.550245 12.0004 0.550245C18.3136 0.550245 23.45 5.68658 23.45 12C23.45 18.3138 18.3136 23.4505 12.0004 23.4505Z" fill="#ffffff" /></g>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs><clipPath id="clip0_2932_1811"><rect width="24" height="24.0006" fill="white" /></clipPath></defs>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== svg || $[8] !== t1) {
    t4 = <svg role="img" className={t1} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...svg}>{t2}{t3}</svg>;
    $[7] = svg;
    $[8] = t1;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
WordPressIcon.displayName = "WordPressIcon";